import { render, staticRenderFns } from "./limitedTimeSingle.vue?vue&type=template&id=2396e3f4&scoped=true&"
import script from "./limitedTimeSingle.vue?vue&type=script&lang=js&"
export * from "./limitedTimeSingle.vue?vue&type=script&lang=js&"
import style0 from "./limitedTimeSingle.vue?vue&type=style&index=0&id=2396e3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2396e3f4",
  null
  
)

export default component.exports